
import { AppImages } from "../assets";

export const navItems = [
  { name: 'Home', path: '#home', active: true },
  { name: 'Services', path: '#services', active: false },
  { name: 'Skills', path: '#skills', active: false },
  { name: 'Projects', path: '#projects', active: false },
  // { name: 'Portfolio', path: '#portfolio', active: false },
  { name: 'Testimonials', path: '#testimonials', active: false },
  { name: 'Contact', path: '#contact', active: false },
  { name: 'Download CV', path: '/ReactNativeCv.pdf', download: true },  // add this

];


export const projects = [
  {
    id: 1,
    title: 'SEVN CLOUDS',
    logo: AppImages.sevnCloudLogo,
    link: 'https://apps.apple.com/us/app/sevn-clouds/id6738123475',
    subscriptionContent: 'Unlock the full experience with access to all 7 calming clouds through a subscription. Enjoy unlimited support whenever you need it, and start with a free one-month trial to explore what works best for you. Continue your subscription afterward to keep SEVN Clouds by your side on your journey to a calmer mind.',
    description: `A simple, intuitive app designed to help you calm your nervous system and regain balance in just a few minutes.
              Have you ever found yourself overwhelmed by anxiety or caught in a panic attack—whether at work, school, or even behind the wheel? SEVN Clouds gently guides you back to calm. Through soothing spoken steps and relaxing sounds, it helps quiet your mind, ease your anxiety, and let you move forward with confidence.

              Explore seven unique clouds, each crafted to support you in moments of stress:

              🌤 Clouds 1–5: Grounding spoken guidance that brings your awareness back to the present and helps you feel safe and centered.

              🌬 Cloud 6: Soft whispering audio designed for those who find whispers especially calming.

              🎵 Cloud 7: A peaceful 432Hz frequency track, scientifically known to reduce anxiety and promote relaxation.

              SEVN Clouds is always within reach—simple, accessible, and ready to help you find calm anytime, anywhere.


`,
    tags: ['React Native', 'Redux', 'Firebase', 'SocialLogin', 'In-App Purchase', 'Audio Player', 'JavaScript'],
    icon: '🛍️',
    coverImage: AppImages.sevnCloudBg,
    color: '#94ace9'
  },
  {
    id: 2,
    title: 'Muslim Calendar',
    logo: AppImages.muslimCalenderLogo,
    link: 'https://apps.apple.com/us/app/muslim-planner-app/id6738999057',
    description: `MuslimPlanner syncs calendars with prayer times to help you organize your day around faith, work, and life.
    MuslimPlanner is an innovative app designed to seamlessly integrate daily prayer times into your professional and personal calendars. With a clean, intuitive interface, it empowers you to plan meetings, tasks, and personal moments without missing your prayers. Personalized reminders keep you on track, while multi-timezone support makes it perfect for frequent travelers and remote workers.
    Beyond scheduling, MuslimPlanner offers task creation, multi-language support, and smooth Google Calendar integration—helping you balance productivity and spirituality every day. Whether you’re managing work deadlines or planning family time, MuslimPlanner ensures your faith always stays at the heart of your routine.`,
    tags: [
      'React Native',
      'Prayer Time APIs',
      'Google Maps API',
      'Multi-language Support',
      'Task Management',
      'Google Calendar Integration',
      'Firebase',
      'Anonymous Authentication',
      'Schedule Notification'
    ],

    icon: '👥',
    coverImage: AppImages.muslimCalender,
    color: '#08898e'
  },
  {
    id: 3,
    title: 'U4RIA',
    logo: AppImages.u4riaLogo,
    description: 'A healthcare mobile app that helps users track medical records, appointments, and medication.Discover a wide range of features tailored to help you reduce stress, improve sleep, and support personal growth. Features include push notifications and integration with health devices.',
    link: 'https://apps.apple.com/pk/app/u4ria/id6466178488',
    androidLink: 'https://play.google.com/store/apps/details?id=com.u4ria&hl=en&pli=1',
    tags: [
      'React Native',
      'MongoDB',
      'API Integration',
      'In-App Purchases',
      'Social Login',
      'Promo Code System',
      'Social Media',
      "Like DisLike comment post video and photo",
      'AI Api'
    ],
    icon: '🏥',
    coverImage: AppImages.u4riaBg,
    color: '#0c3731',
    subscriptionContent: `U4RIA offers a limited-time launch price of $4.99, providing access to premium meditation, breathwork, and mindfulness tools.`
  },
  {
    id: 4,
    title: 'UOB - MugClub',
    logo: AppImages.mugClubLogo,
    androidLink: 'https://play.google.com/store/apps/details?id=com.uobmugclub&pcampaignid=web_share&pli=1',
    description: `Discover the University of Beer Mug Club Membership app – your passport to enjoying great beer at unbeatable prices! As a member, you’ll unlock exclusive perks, including:
    • $5 off beer every week – keep saving on your favorite brews all year long.`,

    tags: ['React Native', 'Spinning Wheel', 'Firebase', 'In-App Purchase', 'Social Logins', 'Redux'],
    subscriptionContent: '$5 off beer every week – keep saving on your favorite brews all year long',
    icon: '🍺',
    coverImage: AppImages.mugClubBg,

    color: '#1c5e8f'
  },
  {
    id: 5,
    title: 'OkTreat-Pet Sitting & Boarding',
    link: 'https://apps.apple.com/us/app/oktreat-pet-sitting-boarding/id6479255523',
    logo: AppImages.okTreatLogo,
    description: `OkTreat – The place to barter your time for a Pet Sitter.
        OkTreat is a platform that connects pet owners with trusted pet service providers for everything from pet sitting and dog walking to boarding. Whether you’re looking for someone to care for your furry friend or you’re a professional offering pet services, OkTreat makes it simple, secure, and rewarding.
        Why choose OkTreat?
        Seamless Booking & Payments: Use our coin-based system to book and pay safely. Buy coins through Stripe, and service providers can easily withdraw their earnings.
        Find & Schedule Services: Quickly browse verified dog sitters, walkers, and boarders, and schedule appointments without hassle.
        In-app Chat & Calls: Communicate directly with service providers through chat and calls before making a booking.
        Secure & Verified: All transactions are protected with Stripe KYC verification to keep both pet owners and providers safe.
        For Pet Professionals: Join as a service provider to earn coins for your services, which can be withdrawn as real money.
        Join the OkTreat community today!
        Give your pet the best care with trusted professionals. Download OkTreat and make pet care simpler than ever.
        `,
    tags: [
      'React Native',
      'Map Sdk',
      'Service and Booking Feature',
      'Pet Care Service and Booking',
      'Firebase',
      'Stripe Payment Gateway',
      'In-app Chat',
      'Notification',
      'Redux Notification',
      'User-Friendly UI',
      'Cloud Function'
    ],
    coverImage: AppImages.okTreatBg,
    icon: '🐶🐱🐾',
    color: '#fec4ec'
  },
  {
    id: 6,
    title: 'Simply Journaling',
    link: 'https://apps.apple.com/pk/app/simply-journaling/id6743721234',
    logo: AppImages.simplyJournalingLogo,
    description: `Simply Journaling – Your All-in-One Journal Hub
Simply Journaling is the ultimate app for mental clarity, emotional well-being, and personal growth. Track daily reflections, log prayers, set goals, and capture memories—all in a beautifully designed and intuitive interface.
Why choose Simply Journaling?
Multiple Journal Types: Gratitude, mental health, dream, prayer, productivity, food, travel, and more.
Guided Prompts & Templates: Inspire your writing and reflection.
Privacy & Security: Protect your entries with password or biometric lock.
Cloud Sync & Backup: Access your journals across all devices.
Personalization: Customize fonts, themes, and layouts to suit your style.
Mood, Habit & Goal Tracking: Stay on top of your personal growth journey.
Export & Print: Keep physical copies of your memories or reflections.
Start your journaling journey today and discover the power of reflection, growth, and mindfulness.`,
    tags: [
      'React Native',
      'Journal App',
      'Mental Health Tracking',
      'Gratitude & Prayer Logs',
      'Cloud Sync',
      'Personalization',
      'Guided Prompts',
      'Secure & Private',
      'Export & Print',
      'User-Friendly UI'
    ],
    coverImage: AppImages.simplyJournalingBg,
    icon: '📔✍️🧘',
    color: '#3e7283'
  },


  {
    id: 7,
    title: 'Activity map',
    androidLink: 'https://play.google.com/store/apps/details?id=com.activitymaps',
    logo: AppImages.activityMapLogo,
    description: `
Activity Maps is an easy-to-use app that helps you discover the best places, activities, and events around you. Whether you are exploring your hometown or visiting a new city, the app provides recommendations that match your interests and lifestyle. You can browse different categories like adventures, family activities, cultural experiences, date spots, sports, workshops, and special events.
The app also lets you read reviews, check menus, see opening hours, and book tickets directly. It is supported by a community of contributors who share local spots and hidden gems, making discovery more authentic and helpful. With multi-language support and personalized suggestions, Activity Maps offers a smooth experience for users worldwide.
Premium users can access extra features such as offline maps, exclusive content, priority support, advanced search filters, and real-time alerts about nearby deals and events. Overall, Activity Maps makes it simple and enjoyable to explore and plan activities in your city.
`,
    tags: [
      'React Native',
      'Recommendations',
      'Reviews',
      'Menus',
      "Booking",
      "Opening Hours",
      "Multi-Language",
      "Personalized Suggestions"
    ],
    coverImage: AppImages.activityMapBg,
    icon: '📔✍️🧘',
    color: '#9383b0'
  },

  //   {
  //     id: 8,
  //     title: 'Find A Dip',
  //     androidLink: 'https://play.google.com/store/apps/details?id=com.activitymaps',
  //     logo: AppImages.activityMapLogo,
  //     description: `
  // Activity Maps is an easy-to-use app that helps you discover the best places, activities, and events around you. Whether you are exploring your hometown or visiting a new city, the app provides recommendations that match your interests and lifestyle. You can browse different categories like adventures, family activities, cultural experiences, date spots, sports, workshops, and special events.
  // The app also lets you read reviews, check menus, see opening hours, and book tickets directly. It is supported by a community of contributors who share local spots and hidden gems, making discovery more authentic and helpful. With multi-language support and personalized suggestions, Activity Maps offers a smooth experience for users worldwide.
  // Premium users can access extra features such as offline maps, exclusive content, priority support, advanced search filters, and real-time alerts about nearby deals and events. Overall, Activity Maps makes it simple and enjoyable to explore and plan activities in your city.
  // `,
  //     tags: [
  //       'React Native',
  //       'Recommendations',
  //       'Reviews',
  //       'Menus',
  //       "Booking",
  //       "Opening Hours",
  //       "Multi-Language",
  //       "Personalized Suggestions"
  //     ],
  //     coverImage: AppImages.activityMapBg,
  //     icon: '📔✍️🧘',
  //     color: '#9383b0'
  //   }

];



export const webProjects = [
  {
    id: 1,
    title: 'A MovieWeb',
    category: 'Web Development',
    projectsName: 'TA MovieWeb',
    url: 'ta-moviexweb.vercel.app',
    githubCode: 'https://github.com/TauseefAlpha/TA-moviexweb',
    coverImage: [AppImages.movieBg, AppImages.topRated, AppImages.trendingMovie],
    tags: [
      'React js',
      'TMDB Database',
      'Java Script',
      '@reduxjs/toolkit',
      'react-player',
      'lazy-load-image',
    ],
    color: '#091b2e',

    image: AppImages.movieBg,
    categories: ['web', 'development']
  },
  {
    id: 2,
    title: 'ShopEase Store',
    category: 'Web Development',
    projectsName: 'ShopEase Store (MERN Stack)',
    url: 'shopease-store-htkm2li3q-ahmedtausef98gmailcoms-projects.vercel.app',
    githubCode: 'https://github.com/TauseefAlpha/fullstackEshoppingwebsite',
    coverImage: [AppImages.shopeaseBg, AppImages.shopeaseProducts, AppImages.shopeaseCart],
    tags: [
      'React js',
      'Node js',
      'Express js',
      'MongoDB',
      'Redux Toolkit',
      'Tailwind CSS',
      'Stripe API',
      'JWT Authentication'
    ],
    color: '#5b75a6',

    image: AppImages.shopeaseBg,
    categories: ['web', 'development']
  }
]